import { Select } from "@fluentui/react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { useBankStatementsStore } from "store/BankStatementsStore";
import { usePaymentPageStore } from "store/PaymentPageStore";

type Props = {
  name: string;
  required?: boolean;
  disabled?: boolean;
  value?: any;
  visible?: boolean;
  isLoading: boolean;
  onBlur?: (e: any) => void;
};

export const SearchDateFilterField = ({
  name,
  required = false,
  disabled = false,
  visible,
  isLoading,
  onBlur = null,
}: Props) => {
  const { t } = useTranslation();
  const [{ searchDateFilterField }, { setBankStatementsStoreValue }] =
    useBankStatementsStore();

  if (!visible) return null;
  return (
    <>
      <Select
        data-help="bank-statements-date-field"
        required={required}
        disabled={disabled || isLoading}
        id={name}
        name={"searchDateFilterField"}
        onBlur={(e) => {
          onBlur && onBlur(e);
        }}
        onChange={(e, data) => {
          setBankStatementsStoreValue("searchDateFilterField", data.value);
        }}
        value={searchDateFilterField || ""}
        title={t("pct.taxonomy.selectTitle.label")}
      >
        <option key={"statementCreatedAt"} value={"statementCreatedAt"}>
          {t("pct.statementCreatedAt.label")}
        </option>
        <option key={"periodFrom"} value={"periodFrom"}>
          {t("pct.periodFrom.label")}
        </option>
        <option key={"periodTo"} value={"periodTo"}>
          {t("pct.periodTo.label")}
        </option>
      </Select>
    </>
  );
};

export default SearchDateFilterField;
